export default __webpack_public_path__ + "static/media/photo8.ff5802f4.jpg";